const POPOVER_GAP = 8;
const VIEWPORT_PADDING = 8;

interface RectPosition {
  top: number;
  right: number;
  bottom: number;
}

interface ElementSize {
  width: number;
  height: number;
}

interface ViewportSize {
  width: number;
  height: number;
}

export function calculatePopoverPosition(
  anchor: RectPosition,
  popover: ElementSize,
  viewport: ViewportSize,
) {
  const maxLeft = Math.max(VIEWPORT_PADDING, viewport.width - VIEWPORT_PADDING - popover.width);
  const left = Math.min(Math.max(VIEWPORT_PADDING, anchor.right - popover.width), maxLeft);

  const topAbove = anchor.top - POPOVER_GAP - popover.height;
  const topBelow = anchor.bottom + POPOVER_GAP;
  const maxTop = Math.max(VIEWPORT_PADDING, viewport.height - VIEWPORT_PADDING - popover.height);
  const fitsAbove = topAbove >= VIEWPORT_PADDING;
  const fitsBelow = topBelow <= maxTop;
  const preferredTop = fitsAbove || !fitsBelow ? topAbove : topBelow;
  const top = Math.min(Math.max(VIEWPORT_PADDING, preferredTop), maxTop);

  return { top, left };
}
